import { render, staticRenderFns } from "./payCheck.vue?vue&type=template&id=a6fa0dbe&scoped=true&"
import script from "./payCheck.vue?vue&type=script&lang=js&"
export * from "./payCheck.vue?vue&type=script&lang=js&"
import style0 from "./payCheck.vue?vue&type=style&index=0&id=a6fa0dbe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6fa0dbe",
  null
  
)

export default component.exports